import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';

import { trpc } from './trpc';

type OutputRouter = inferRouterOutputs<AppRouter>;
type InputRouter = inferRouterInputs<AppRouter>;

export type AuditEventsListOutput = OutputRouter['audit']['list'];
export type AuditEvent = AuditEventsListOutput['auditEvents'][number];
export type AuditEventOptions = AuditEventsListOutput['options'];
export type AuditEventsListInput = InputRouter['audit']['list'];

/**
 * Hook to list audit events with pagination, sorting and filters
 */
export function useAuditEventsList(params?: Parameters<typeof trpc.audit.list.useQuery>[0]) {
  return trpc.audit.list.useQuery(
    params ?? {
      pagination: { page: 1, pageSize: 20 },
      sortBy: { field: 'createdAt', direction: 'desc' },
    },
  );
}
